import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
// import { COLOR } from '@src/styles/color';

const StyledDialog = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};

  .MuiDialog-paper {
    border-radius: 16px;
    margin: 16px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${(props) => props.paddingHeader || '8px 30px'};
  }

  .dialog-wrapper {
    gap: 22px;
    width: ${(props) => props?.fitWidth && '340px'};
  }

  .dialog-title {
    display: flex;
    gap: 8px;
    align-items: center;

    .icon {
      width: 24px;
      height: 24px;
    }

    .title {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: -0.4px;
    }
  }

  .dialog-message {
    padding: ${(props) => props.padding || '12px 45px'};

    .title-message {
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 28px; /* 140% */
      letter-spacing: -0.4px;
      margin-bottom: 8px;
    }

    .description {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.4px;
    }
  }

  .content-wrapper {
    margin-bottom: 14px;
  }

  .btn-understood {
    margin-right: 24px;
    min-width: 120px;
    padding: 8px 12px;
    border-radius: 12px;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    text-transform: none;
  }

  .cancel-btn {
    border-color: ${COLOR.secondary[32]};
  }

  .non-vbee-warning {
    margin-left: 24px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .not-show-again-text {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      color: ${COLOR.indigo.default};
    }

    .btn-non-vbee-warning {
      padding: 10px 24px;
      margin-right: 8px;
      border-radius: 12px;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      text-transform: none;
    }
  }

  .btn-close-popup {
    border-radius: 12px;
    padding: 8px 24px;
    margin-left: auto;
    text-transform: none;
    font-size: 14px;
    font-weight: 700;
  }

  .change-format-button {
    display: flex;
    gap: 4px;
    justify-content: center;
    align-items: center;
    .btn {
      margin-right: 24px;
      min-width: 120px;
      padding: 8px 12px;
      border-radius: 12px;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      text-transform: none;
    }

    .btn-cancel {
      margin-right: 0px;
    }
  }

  @media only screen and (max-width: 768px) {
    .header {
      padding: 6px 16px;
    }

    .dialog-title {
      display: flex;
      gap: 8px;
      align-items: center;

      .icon {
        width: 24px;
        height: 24px;
      }

      .title {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.4px;
      }
    }

    .dialog-wrapper {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }

    .dialog-title {
      text-align: left;
      font-weight: 700;
    }

    .dialog-action {
      justify-content: center;
      align-items: center;
      gap: 10px;
    }

    .dialog-message {
      padding: 12px 24px;

      .title-message {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        letter-spacing: -0.4px;
      }

      .description {
        font-size: 14px;
        margin-left: 0px;
      }
    }

    .content-wrapper {
      margin-bottom: 4px;
    }

    .btn-understood {
      width: 100%;
      margin: 0px 4px;
      padding: 8px;
      font-size: 14px;
    }

    .non-vbee-warning {
      margin-top: -14px;
      margin-left: 0px;
      width: 100%;
      display: block;

      .not-show-again-text {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
      }

      .btn-group {
        margin-top: 8px;
        display: flex;
        flex-direction: column-reverse;
        gap: 8px;
      }

      .btn-non-vbee-warning {
        margin-right: 8px;
        border-radius: 12px;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        text-transform: none;
        width: 100%;
      }
    }
  }
`;
export { StyledDialog };
